<template>
    <div>
        <!-- <div class="flex items-center">
            <div class="w-10">
                <img class="w-full" :src="agencyLogoUrl()">
            </div>
            <div class="text-red-500 font-bold text-sm">
                {{campaign.agencyName}}
            </div>
        </div>-->
        <div class="font-medium text-base text-dark-2 font-main-medium break-normal break-words" data-cy="text_detail_info_name">{{ campaignName }}</div>
        <!-- <div
            class="text-sm text-gray-400"
        >{{ FilterStringFormat(lbl.detail.expire_date, FilterDateFormat(campaign.expireDate)) }}</div>
        <div class="text-blue-400">{{ getPointTxt() }}</div>-->
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailInfo",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    computed: {
        campaignName: function () {

            if (this.campaign != null) {
                // return this.campaign.name
                if (this.localeCode == 1033) {
                    return this.campaign.nameEn || this.campaign.name
                } else if (this.localeCode == 1054) {
                    return this.campaign.nameTh || this.campaign.name
                } else {
                    return this.campaign.name || this.campaign.name
                }
            }

            return ""
        }
    },
    methods: {
        getPointTxt: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                ? this.lbl.detail.get_point
                : this.lbl.detail.use_point;

            var pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                ? this.lbl.detail.point_unit + 's'
                : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.campaign.pointPerUnit} ${pointUnit}`;
        },
        agencyLogoUrl: function () {
            return ConfigManager.getBlobUrl() + "/agencies/" + this.campaign.agencyID;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
